module.exports = new __parcel__URL__("user.1188935c.svg").toString();